import { range } from "lodash"
import { Sprites } from "../../../utils/Sprites"
import { MakeVideoAtlases } from "../MakeVideoAssets"
import { MakeVideoSprite } from "../MakeVideoTypes"

export class MakeVideoThoughtBubbleSprite implements MakeVideoSprite {
    private static START = "START"

    active: boolean
    private sprite: Phaser.Sprite

    constructor(game: Phaser.Game, group: Phaser.Group, x: number, y: number, debug: boolean) {
        this.sprite = Sprites.add(game, MakeVideoAtlases.THOUGHT_BUBBLE, {debug, group, x, y})
        this.sprite.animations.add(MakeVideoThoughtBubbleSprite.START, range(5), 5, false)
        this.visible = false
        this.active = true
    }

    destroy = () => {
        this.sprite.destroy(true)
        this.active = false
    }

    start = () => {
        if (!this.visible) {
            this.visible = true
        }
        this.sprite.animations.play(MakeVideoThoughtBubbleSprite.START)
    }

    set visible(visible: boolean) {
        this.sprite.visible = visible
    }
}